import mutators from '@/models'

const fields = [
  {
    name: 'Id',
    field: 'id',
    visible: false,
    sortable: false,
    filterable: false,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Posição',
    field: 'position',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Lote',
    field: 'batch',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Código Entidade',
    field: 'entity_code',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Código Cliente',
    field: 'client_code',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Código SPMS',
    field: 'spms',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Designação do Artigo',
    field: 'designation',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Preço/unid s/ IVA',
    field: 'price_unit',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Preço/cx s/ IVA',
    field: 'price_package',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'IVA',
    field: 'tax',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Quantidade Pedida (unid.)',
    field: 'quantity',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Quantidade Pedida (caixa)',
    field: 'quantity_package',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Quantidade de Unidades (caixa)',
    field: 'quantity_per_package',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Desconto Comercial',
    field: 'commercial_discount',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Preço Total',
    field: 'total_price',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Observations',
    field: 'observations',
    visible: false,
    sortable: false,
    filterable: false,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Outros Campos',
    field: 'other_fields',
    visible: false,
    sortable: false,
    filterable: false,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Data Inserção',
    field: 'created_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Última Atualização',
    field: 'updated_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Eliminação',
    field: 'deleted_at',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'date',
    rules: {
      required: false
    }
  }
]

const rules = mutators.rules(fields)
const empty = mutators.empty(fields)
const filters = mutators.filters(fields)

export default {
  fields,
  rules,
  empty,
  filters
}
